




import {
  defineComponent,
  onMounted,
  ref,
  PropType,
  onUnmounted,
  computed,
} from "@vue/composition-api";

import Tinybox from "vue-tinybox";
import { get } from "lodash-es";

interface ImageData {
  src: string;
  caption: string;
  alt: string;
  index: string;
}

export default defineComponent({
  name: "Lightbox",
  props: {
    overlays: {
      type: Array as PropType<HTMLImageElement[]>,
      default: () => [],
    },
    images: {
      type: Array as PropType<ImageData[]>,
      default: () => [],
    },
  },
  components: {
    Tinybox,
  },
  setup(props) {
    const index = ref(null);
    const computedImages = computed(() => {
      const allImages: ImageData[] = [];

      props.images.forEach((image) => {
        let transformedImage = image;

        if (image.src && !(image.src as string).startsWith("/")) {
          transformedImage = {
            ...image,
            src: `/${image.src}`,
          };
        }

        allImages.push(transformedImage);
      });

      return allImages;
    });

    const clickListener = (i: number) =>
      ref(() => {
        index.value = get(props.images, `${i}.index`, null);
      });

    onMounted(() => {
      props.overlays.forEach((overlay: HTMLImageElement, i) => {
        overlay.addEventListener("click", clickListener(i).value);
      });
    });

    onUnmounted(() => {
      props.overlays.forEach((overlay: HTMLImageElement, i) => {
        overlay.removeEventListener("click", clickListener(i).value);
      });
    });

    return {
      index,
      computedImages,
    };
  },
});
